import React, {Component} from 'react'
import {Modal, ModalHeader, ModalBody, ModalFooter} from "reactstrap";
import Swal from "sweetalert2";

class EditIpWhitelist extends Component {
    constructor(props) {
        super(props)
        this.state = {
            prosesSimpan: false
        }
    }

    handleEdit = () => {
        this.setState({ prosesSimpan: true})
        let form = {
            whitelist_id : this.props.data.whitelist_id,
            ip_start: this.props.data.ip_start,
            ip_end: this.props.data.ip_end,
        }
        this.props.request("whitelist/edit", form, 'POST')
            .then((response) => {
                if (response.success) {
                    this.props.changeState({
                        modal_edit: false,
                        data: [],
                    }, () => this.props.loadData())
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.message,
                        icon: 'success',
                        confirmButtonText: 'OK'
                    })
                } else {
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.message,
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    })
                }
                this.setState({ ip_start: '', ip_end: '', prosesSimpan: false })
            })
    }

    render() {
        const isRange = this.props.isRange === true
        return (
            <Modal isOpen={this.props.modal_edit} toggle={() => this.props.changeState({ modal_edit: false })} style={{ maxWidth: "1000px"}} zIndex={999}>
                <ModalHeader className="pengumuman-modal-header" toggle={() => this.props.changeState({ modal_edit: false })}>
                    <div className='presensi-modal-title'>Edit IP Whitelist</div>
                </ModalHeader>
                <ModalBody className="pengumuman-modal-body">
                    <div className="row p-3">
                        <div className="col">
                            <div className="form-group">
                                <div className="row">
                                    <div className="col">
                                        <label className="pengumuman-label-input">
                                            {isRange ? "Dari" : "IP Address"}
                                        </label>
                                        <input type='text' onChange={this.props.handleInputIP}
                                               name='ip_start' value={this.props.data.ip_start}
                                               className='form-control font-12'
                                               placeholder="Masukkan IP (ex : 192.168.1.x)">
                                        </input>
                                    </div>
                                    {isRange &&
                                        <div className="col">
                                            <label className="pengumuman-label-input">
                                                Sampai
                                            </label>
                                            <input type='text' onChange={this.props.handleInputIP}
                                                   name='ip_end' value={this.props.data.ip_end}
                                                   className='form-control font-12'
                                                   placeholder="Masukkan IP (ex : 192.168.1.x)">
                                            </input>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter className="pengumuman-modal-footer">
                    <button onClick={() => this.props.changeState({modal_edit: false})}
                            className='btn text-capitalize batalkan-add-jamker'>Batal</button>
                    <button className='btn btn-primary text-capitalize' disabled={this.state.prosesSimpan}
                            style={{padding: "8px 14px", fontWeight: 500, fontSize: "14px", lineHeight: "24px"}}
                            onClick={this.handleEdit}>{this.state.prosesSimpan ? "Menyimpan" : "Simpan"}
                    </button>
                </ModalFooter>
            </Modal>
        )
    }
}

export default EditIpWhitelist;